<template>
    <v-card elevation="8" class="rounded-lg">
        <!-- 헤더 -->
        <v-card-title style="background-color:#4E87DD;" class="white--text pa-6">
            <span class="text-h5 font-weight-bold">{{ title }}</span>
            <v-spacer></v-spacer>
            <v-btn icon color="white" @click="cancelCard()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <!-- 검색 영역 -->
        <v-card-text class="pa-6">
            <v-card flat style="background-color:#F4F6F8;" class="pa-4 mb-4 rounded-lg">
                <v-row align="center">
                    <v-col cols="9">
                        <v-text-field
                            v-model="searchKeyword"
                            prepend-inner-icon="mdi-map-marker"
                            outlined
                            dense
                            hide-details
                            @keydown.enter="searchAddr"
                            placeholder="예: 서울시 강남구 테헤란로"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-btn
                            color="primary"
                            large
                            block
                            elevation="2"
                            @click="searchAddr()"
                            :loading="loading"
                            class="rounded-lg font-weight-bold"
                        >
                            <v-icon left>mdi-magnify</v-icon>
                            검색
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>

            <!-- 검색 결과 -->
            <div v-if="searched">
                <div class="d-flex align-center mb-3">
                    <v-icon color="primary" class="mr-2">mdi-format-list-bulleted</v-icon>
                    <span class="text-h6 font-weight-medium">검색 결과</span>
                    <span class="ml-2 text-h6 font-weight-bold" style="color: #1976d2;" v-if="addrList.length > 0">
                        ({{ addrList.length }}건)
                    </span>
                </div>

                <v-card flat v-if="addrList.length === 0" class="text-center pa-8">
                    <v-icon size="64" color="grey lighten-2">mdi-map-marker-off</v-icon>
                    <div class="text-h6 grey--text mt-3">검색 결과가 없습니다</div>
                    <div class="grey--text">다른 키워드로 검색해보세요</div>
                </v-card>

                <v-card flat outlined class="rounded-lg" style="max-height: 400px; overflow-y: auto;" ref="tableContainer" v-if="addrList.length > 0">
                    <v-simple-table>
                        <thead>
                            <tr style="background-color:#F4F6F8;">
                                <th class="text-left font-weight-bold">우편번호</th>
                                <th class="text-left font-weight-bold">주소</th>
                                <th class="text-center font-weight-bold">선택</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(addr, addrIdx) in addrList" :key="`${addr.addr_no}_${addrIdx}`" class="table-row">
                                <td class="text-body-2">{{ addr.post_no }}</td>
                                <td class="text-body-2">{{ addr.addr1 }} {{ addr.bd_nm }}</td>
                                <td class="text-center">
                                    <v-btn
                                        small
                                        color="primary"
                                        @click.stop="selectAddr(addr)"
                                        class="rounded-pill"
                                    >
                                        선택
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
                
                <!-- 더보기 버튼 -->
                <div class="text-center mt-3" v-if="addrList.length > 0">
                    <v-btn
                        outlined
                        color="primary"
                        @click="loadMore()"
                        :loading="loadingMore"
                        class="rounded-lg"
                        v-show="showMore"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        더보기
                    </v-btn>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import svcWvApi from '@/api/svc_wv'

export default {
    props: {
        title: String,
        modify: Boolean,
        group: {
            type: Object,
            default: function () {
                return {
                    id: -1,
                    name: '',
                    children: [],
                    members: []
                }
            }
        }
    },
    data: () => ({
        submitDisabled: true,
        searchKeyword: '',
        pageNo: 1,
        addrList: [],
        searched: false,
        loading: false,
        loadingMore: false,
        showMore: false,
        totalCount: 0
    }),
    methods: {
        searchAddr() {
            let ctx = this

            if (this.searchKeyword.trim() === '') {
                ctx.$store.dispatch('openAlert', {message: '주소를 입력해 주세요.'})
                return
            }

            // 이미 로딩 중이면 중복 호출 방지
            if (this.loading) {
                return
            }

            this.pageNo = 1 // 새 검색 시 페이지 초기화
            this.loading = true
            let scb = function (addr_list, total_count) {
                ctx.addrList.splice(0, ctx.addrList.length)
                ctx.totalCount = total_count || 0
                
                if (addr_list && addr_list.length > 0) {
                    addr_list.forEach((item, idx) => {
                        ctx.addrList.push(item)
                    })
                }
                
                // 더보기 버튼 표시 여부 결정
                ctx.showMore = ctx.addrList.length < ctx.totalCount
                
                ctx.searched = true
                ctx.loading = false
            }
            let fcb = function (err) {
                alert('검색을 실패했습니다: ' + err)
                ctx.loading = false
            }

            svcWvApi.searchAddr(this.searchKeyword, this.pageNo, scb, fcb)
        },
        loadMore() {
            this.pageNo += 1
            this.loadingMore = true
            
            let ctx = this
            let scb = function (addr_list) {
                if (addr_list && addr_list.length > 0) {
                    addr_list.forEach((item, idx) => {
                        ctx.addrList.push(item)
                    })
                }
                
                // 더보기 버튼 표시 여부 결정
                ctx.showMore = ctx.addrList.length < ctx.totalCount
                
                ctx.loadingMore = false
                
                // 스크롤을 최하단으로 스무스하게 이동
                ctx.$nextTick(() => {
                    const container = ctx.$refs.tableContainer.$el
                    container.scrollTo({
                        top: container.scrollHeight,
                        behavior: 'smooth'
                    })
                })
            }
            let fcb = function (err) {
                alert('더보기를 실패했습니다: ' + err)
                ctx.loadingMore = false
                ctx.pageNo -= 1 // 실패 시 페이지 번호 되돌리기
            }
            
            svcWvApi.searchAddr(this.searchKeyword, this.pageNo, scb, fcb)
        },
        selectAddr(addr) {
            this.$emit('submit', addr)
        },
        cancelCard() {
            this.$emit('cancel')
        }
    }
}
</script>

<style scoped>
.table-row {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.table-row:hover {
    background-color: #f5f5f5 !important;
}
</style>